<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <file-down></file-down>
  </div>
</template>
<script>
import Cookie from 'js-cookie'

export default {
  data() {
    return {
      username: ''
    }
  },
  watch: {
    $route(to) {
      //路由变化关闭加载中动画
      this.$toast.clear()
      document.title = to.meta.title
      this.bus.$emit('hideFileDown')
    }
  },
  methods: {
    joyaLoad() {
      let _userName = Cookie.get('ciftis_user_name')
      let _account = Cookie.get('ciftis_account_name')
      if (_userName) {
        //      if (_userName) window.jaq.push(['erp_account', _userName])
        let _account_val = _userName + (_account ? '@' + _account : '')
        if (window._isMobile) window.jap.account = _account_val
        else window.jaq.push(['erp_account', _account_val])
      }
      try {
        ;(() => {
          var ja = document.createElement('script')
          ja.type = 'text/javascript'
          ja.async = true
          ja.src = window._isMobile
            ? '//wl.jd.com/unify.min.js'
            : '//wl.jd.com/joya.js'
          var s = document.getElementsByTagName('script')[0]
          s.parentNode.insertBefore(ja, s)
        })()
      } catch (_err) {
        console.log(_err)
      }
    }
  },
  created() {
    this.joyaLoad()
  },
  mounted() {
    this.$base.focusout() //键盘事件优化
  }
}
</script>
<style>
.mainCon {
  width: 100%;
  height: 100%;
  font-size: 14px;
  list-style: none;
  display: flex;
  flex-direction: column;
}
.page-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: #fff;
  overflow-y: scroll;
  /* -webkit-overflow-scrolling: touch; */
}
</style>
